import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../App";

export default function TempConvoLauncher() {
    const nav = useNavigate();
    const [otherUserId, setOtherUserId] = useState("");
    const [err, setErr] = useState("");

    const launch = async () => {
        setErr("");
        try {
            const res = await fetch(`${BASE_URL}/backend/messages/ensure_conversation.php`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ other_user_id: Number(otherUserId) })
            });
            const data = await res.json();
            if (!res.ok || data.error) throw new Error(data.error || "Failed.");
            nav(`/messages/${data.conversation_id}`);
        } catch (e) {
            setErr(e.message);
        }
    };

    return (
        <div style={{ padding: 24 }}>
            <h2>Dev: Launch a DM</h2>
            <input
                type="number"
                placeholder="Other user ID"
                value={otherUserId}
                onChange={(e) => setOtherUserId(e.target.value)}
            />
            <button onClick={launch}>Open/Create Conversation</button>
            {err && <div style={{ color: "crimson" }}>{err}</div>}
        </div>
    );
}
